import { Stack, useRouter } from 'expo-router';
import { useDepositCashFlow } from 'features/moveMoney/providers/DepositCashFlowContextProvider';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';

export default function DownloadAppErrorScreen() {
  const router = useRouter();
  const { t: translatedText } = useTranslation('moveMoney');
  const { flowName } = useDepositCashFlow();

  useViewDidFocusScreenAnalyticsEvent({
    key: '/move-money/deposit-cash/barcode/app-required-error',
    customAttributes: {
      name: 'App Required for Cash Deposits Error',
      category: 'deposit_cash',
      subcategory: 'cash_deposit_barcode',
      flow_name: flowName,
    },
  });

  const handleClicksBackAnalytics = usePressableAnalytics({
    analyticsId: 'clicksBackAppError',
    customAttributes: {
      category: 'deposit_cash',
      source_name: 'cash_deposit_location_map',
      subcategory: 'cash_deposit_barcode',
      flow_name: flowName,
    },
  });

  const handleGoBack = () => {
    handleClicksBackAnalytics();
    if (router.canGoBack()) {
      router.back();
    }
  };

  return (
    <>
      <Stack.Screen
        options={{
          headerShown: false,
        }}
      />
      <ErrorScreen
        screenType={ErrorScreenType.Error}
        messageHeadline={translatedText(
          'depositCash.barcode.downloadApp.title',
        )}
        messageBody={translatedText('depositCash.barcode.downloadApp.subtitle')}
        primaryButton={{
          title: translatedText('depositCash.barcode.downloadApp.backButton'),
          onPress: handleGoBack,
        }}
        insetBottomSafeArea={true}
      />
    </>
  );
}
